import React, { Children } from 'react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import {
    ChevronWrapper,
    CollapseChildren,
    CollapseLabel,
    CollapseWrapper,
    SectionTitle,
} from 'src/ui/components/collapse/sports/05/Collapse.style';
import { observer } from 'src/utils/mobx-react';

export interface CollapsePropsType {
    children?: React.ReactNode;
    className?: string;
    dataTest?: string;
    dataTestMarketName?: string;
    handleToggle?: () => void;
    isOpen: boolean;
    title: React.ReactNode;
    collapsible?: boolean;
    type?: 'default' | 'header';
}

/**
 * This component will be used for sections:
 * - **competitions**
 * - **markets**
 * - **live tracker**
 */

export const Collapse = observer(
    'Collapse',
    ({
        children,
        className,
        dataTest,
        dataTestMarketName,
        handleToggle,
        isOpen,
        title,
        collapsible = true,
        type = 'default',
    }: CollapsePropsType): JSX.Element => {
        const hasChildren = Children.count(children) > 0;
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;

        return (
            <CollapseWrapper
                data-testid={dataTest}
                isOpen={isOpen}
                onClick={collapsible ? handleToggle : () => {}}
                className={className}
                variant={configState.componentVariants.collapseVariant}
                type={type}
            >
                <CollapseLabel>
                    <SectionTitle
                        data-test-market-name={dataTestMarketName ?? 'market-name'}
                        data-test='section-title'
                    >
                        {title}
                    </SectionTitle>
                    {collapsible ? <ChevronWrapper position={isOpen ? 'up' : 'down'} /> : null}
                </CollapseLabel>

                {hasChildren && <CollapseChildren>{children}</CollapseChildren>}
            </CollapseWrapper>
        );
    }
);
